<button
  type="button"
  [ngClass]="{ loaded: loaded }"
  class="{{ colour }} {{ size }} position-relative"
  [disabled]="disabled || isLoading"
  [style.width]="width"
  (click)="!disabled && buttonClicked.emit()">
  <img [class.invisible]="isLoading" [class]="size" *ngIf="leftIconSrc" [src]="leftIconSrc" alt="" />
  <div [class.invisible]="isLoading">
    <ng-content></ng-content>
  </div>
  <img [class]="size" [class.invisible]="isLoading" *ngIf="rightIconSrc" [src]="rightIconSrc" alt="" />
  <img *ngIf="isLoading" class="loading-icon" [src]="loadingIconSrc" alt="loading" i18n-alt />
</button>
